import { FormControl, InputLabel, InputAdornment } from "@mui/material"
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { useEffect, useState } from "react";
import { setCategory } from "../utils/database";
import { ciEquals } from "../utils/strings";
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Helper from "./Helper";
import Stack from '@mui/material/Stack';
import FormHelperText from '@mui/material/FormHelperText';
import { capitalizeText } from "../utils/strings";
import EasySnackBar from "./EasySnackBar";

export default function AddProductCategories(props) {
    const [newCategory, setNewCategory] = useState("")
    const [productCategory, setProductCategory] = useState("")

    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')

    useEffect(() => {
        setProductCategory(props.productCategory)
    }, [props.productCategory])

    const handleCategoryChange = category => {
        setProductCategory(category)
        props.setProductCategory(category)
    };

    const addCategory = () => {
        if (newCategory !== "") {

            let categoryExists = false
            if (props.allCategories) {
                for (let i = 0; i < Object.values(props.allCategories).length; i++) {

                    if (ciEquals(Object.values(props.allCategories)[i], newCategory)) {

                        setErrorMessage('Ya existe una categoria con ese nombre')
                        categoryExists = true
                        break
                    }
                }

                if (!categoryExists) {
                    const capitalizedCategory = capitalizeText(newCategory)
                    setCategory(props.userAuth, props.menuID, Object.values(props.allCategories).length, capitalizedCategory)

                    props.setProductCategory(capitalizedCategory)
                    setProductCategory(capitalizedCategory)
                    props.updateUserMenu()
                    setSuccessMessage('Nueva categoria creada')
                }

            } else {
                //No hay categorias previas
                const capitalizedCategory = capitalizeText(newCategory)
                setCategory(props.userAuth, props.menuID, 0, capitalizedCategory)

                props.setProductCategory(capitalizedCategory)
                setProductCategory(capitalizedCategory)
                props.updateUserMenu()
                setSuccessMessage('Nueva categoria creada')
            }

        } else {
            setErrorMessage('El nombre de la categoria no puede estar vacio')
        }
    }

    return (
        <>
            {!props.allCategories ? null :
                <Stack direction='row'>
                    <FormControl sx={{ width: '100%' }}>
                        <InputLabel id="demo-simple-select-helper-label">Categoria actual</InputLabel>
                        <Select
                            labelId="demo-simple-select-helper-label"
                            id="demo-simple-select-helper"
                            value={productCategory}
                            label="Categoria actual"
                            onChange={e => handleCategoryChange(e.target.value)}
                        >

                            {Object.values(props.allCategories).map(category => {
                                return (
                                    <MenuItem value={category} key={category}>
                                        {category}
                                    </MenuItem>
                                )
                            })}

                        </Select>
                        <FormHelperText>Categoria a la que pertenece el producto</FormHelperText>
                    </FormControl>
                    <Helper
                        text='Debes seleccionar una categoria a la que pertenece tu producto'
                        style={{ marginBottom: '20px' }}
                    />
                </Stack>
            }

            <Stack direction='row'>
                <FormControl variant="outlined" sx={{ width: '100%' }}>
                    <InputLabel htmlFor="outlined-adornment-password">Nueva categoria</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        onChange={e => e.target.value.length <= 100 ? setNewCategory(e.target.value) : null}
                        value={newCategory}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                addCategory();
                            }
                        }}
                        endAdornment={
                            <InputAdornment position="end">

                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                <IconButton
                                    onClick={addCategory}
                                    color="primary"
                                >
                                    <AddCircleOutlineOutlinedIcon />
                                </IconButton>

                            </InputAdornment>
                        }
                        label="Nueva categoria"
                    />
                    <FormHelperText>Maximo 100 caracteres | Presiona enter para crear</FormHelperText>
                </FormControl>

                <Helper text='Si el producto no pertenece a ninguna de las categorias existentes puedes crear una nueva' style={{ marginBottom: '20px' }} />
            </Stack>

            <EasySnackBar
                severity='error'
                key='1'
                message={errorMessage}
                setMessage={setErrorMessage}
            />

            <EasySnackBar
                severity='success'
                key='2'
                message={successMessage}
                setMessage={setSuccessMessage}
            />
        </>
    )
}